import snakecaseKeys from 'snakecase-keys';
import { restClient } from '../../client';


type GetBuilderHooksResponse = {
  preprocess: {
    label: string;
    value: string;
  }[];
  postprocess: {
    label: string;
    value: string;
  }[];
};

export type SettingsInput = {
  settingsId: string | null;
  defaultExpiration: number;
  isAssessment: boolean;
  preProcessHook: string;
  postProcessHook: string;
  notificationThreshold: number | null;
  showInClientProfile: boolean;
};

export type SettingsResponse = {
  data: {
    defaultExpiration: number | null;
    formId: string;
    formSettingId: string;
    isAssessment: boolean;
    notificationThreshold: number | null;
    postProcessHook: string;
    preProcessHook: string;
    showInClientProfile: boolean;
  };
};

export const getBuilderHooks = restClient.createRequest<null, GetBuilderHooksResponse>({
  url: '/api/v1/form_admin/available_processes',
  method: 'GET',
});

export const getFormSettings = (form_id: string) =>
  restClient.request<SettingsResponse>(`/api/v1/form_admin/form/${form_id}/settings`, { method: 'GET' });

export const updateFormSettings = (form_id: string, settings: SettingsInput) =>
  restClient.request<SettingsResponse>(`/api/v1/form_admin/form/${form_id}/settings`, {
    method: 'POST',
    data: snakecaseKeys(settings),
  });
